<template>
  <div class="fund">
    <!-- <img alt="Vue logo" src="../assets/logo.png"> -->
    <el-row :gutter="20">
      <el-col :span="12">
        <h4 class="text-left">持有金额合计：{{amountTotal}}</h4>
      </el-col>
      <el-col :span="12">
        <h4 class="text-right">估算金额合计：
          <span :class="gsjeTotalCls">{{gsjeTotal}}</span>
          <el-button type="primary" size="mini" plain  @click="refreshTotal">
            <el-icon>
              <refresh/>
            </el-icon>
            刷新
          </el-button>
      </h4>
      </el-col>
    </el-row>  
    <hr>
    <ListView :tableData="zxFundList" :selectedRow="currentRow" @handlerListSelected="handlerListSelected" />
    <br>
    <el-row :gutter="20">
      <el-col :span="8">
        <el-input
          v-model="queryString"
          clearable 
          placeholder="输入代码或名称"
          @keydown.enter="handlerInpuEnter"
        />
      </el-col>

      <el-col :span="5">
        <el-button 
          type="primary" 
          @click="handlerAddZX"
          >
          <el-icon>
            <circle-plus/>
          </el-icon>
          添加
        </el-button>
      </el-col>

      <el-col :span="5">
        <el-button 
          type="warning" 
          @click="handlerDelZX"
          >
          <el-icon>
            <delete/>
          </el-icon>
          移除
        </el-button>
      </el-col>

      <el-col :span="5">
        <el-button 
          type="warning" 
          @click="handlerSetAmount"
          >
          <el-icon>
            <edit/>
          </el-icon>
          设置
        </el-button>
      </el-col>

      <el-col :span="8" class="list" v-show="!hideSelect">
        <ul>
          <li v-for="fund in filterList" :key="fund[0]" @click="handlerSelected(fund)">
            <div>{{ fund[0]}} - {{fund[2]}}</div>
          </li>
        </ul>
      </el-col>
    </el-row>
  </div>
  
</template>

<script>
import { ElMessageBox , ElMessage } from 'element-plus'
import { Refresh,CirclePlus,Delete,Edit } from '@element-plus/icons'
// @ is an alias to /src
import ListView from '@/views/Com/ListView.vue'

import Tools from '@/tools/tools.js'

export default {
  name: 'Fund',
  components: {
    ListView,
    Refresh,CirclePlus,Delete,Edit
  },
  data(){
    return{
      queryString:'',
      allFundList:[],
      zxFundList:[],
      currentRow:null,
      amountTotal:0,
      gsjeTotal:0,
    }
  },
  methods:{
    handlerInpuEnter(){
      if(!this.hideSelect)
      {
        this.handlerSelected(this.filterList[0])
      }
    },
    handlerSelected(fund){
      this.queryString=fund[0]+' - '+fund[2]
    },
    handlerAddZX(){
      if(/^(\d{6}) - .*/.test(this.queryString))
      {
        var code = this.queryString.substr(0,6)
        if(!this.zxFundList.find(f=>f.fundcode==code)){        
            //获取基金信息
            Tools.getFundInfo(code).then(fundObj=>{
              console.log('fundObj',fundObj);
              fundObj.amount = 0
                fundObj.gsje = 0
                this.zxFundList.push(fundObj) 
            }).catch(failObj=>{
              ElMessage(failObj)
            })
        }
        else
        {
          ElMessage({
            message: '该基金已存在自选',
            type: 'warning',
          })
        }
      }
      else
      {
        ElMessage.error('输入的基金代码有误')
      }
      this.queryString=''
    },
    handlerListSelected(selObj){
      this.currentRow = selObj
    },
    handlerSetAmount(){
      if(this.currentRow){
        ElMessageBox.prompt('请输入金额', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /[0-9.]*/,
          inputValue:this.currentRow.amount*this.currentRow.dwjz,
          inputErrorMessage: '请输入数字',
        })
        .then(({ value }) => {
          this.currentRow.amount=Number(value)/this.currentRow.dwjz
          this.refrushInfo(this.currentRow)
        })
      }
      else
      {
        ElMessage.error('没有选中的基金')
      }
    },
    handlerDelZX(){
      if(this.currentRow){
        var index = this.zxFundList.indexOf(this.currentRow); 
        if (index > -1) { 
          this.zxFundList.splice(index, 1)
          this.currentRow = null
        } 
      }
      else
      {
        ElMessage.error('没有选中的基金')
      }
    },
    handlerSearch(queryString){
      //console.log('@',this.queryString,this.allFundList,this.filterList)
      var fList = this.allFundList.filter(fund=>(fund[0].indexOf(queryString)!=-1)||(fund[2].indexOf(queryString)!=-1))
      if(fList.length>100){
       return fList.slice(0,100)
      }
      else
      {
        return fList
      }
    },
    refrushInfo(Obj)
    {
      //获取基金信息
      Tools.getFundInfo(Obj.fundcode).then(fundObj=>{
          //console.log('Obj:',Obj,'fundObj:',fundObj)
          Object.assign(Obj,fundObj)
          //console.log('Obj:',Obj,'fundObj:',fundObj)
          //更新金额
          Obj.gszzl = Number(Obj.gszzl)
          Obj.gsje = Obj.amount*Obj.dwjz*Obj.gszzl/100
        }).catch(failObj=>{
          console.log(failObj)
        })
    },
    refreshTotal(){
      console.log('refreshTotal')
      this.zxFundList.forEach(fund=>{
        this.refrushInfo(fund)
      })
    },
    //更新总额
    calcTotal()
    {
      var amountAll = 0
      var gsjeAll = 0
      this.zxFundList.forEach(fund=>{
        if(fund){
        amountAll+=Number(fund.amount*fund.dwjz)
        gsjeAll+=Number(fund.gsje)
        }
      })
      this.amountTotal = amountAll.toFixed(2)
      this.gsjeTotal = gsjeAll.toFixed(2)
    }
  },
  computed:{
    filterList:function(){
      return this.handlerSearch(this.queryString)
    },
    hideSelect:function(){
      return this.queryString.length==0||/^(\d{6}) - .*/.test(this.queryString)
    },
    gsjeTotalCls:function()
    {
      return this.gsjeTotal>0?'color-red':'color-green'
    }
  },
  watch:{
      //自动保存自选列表
      zxFundList:{
          deep:true,
          handler: function(newVal, oldVal) {
              var that=this;
              console.log('newVal',newVal,JSON.stringify(newVal));
              if(localStorage.getItem('zxFundList')==JSON.stringify(newVal))
              {
                //未改变
                return;
              }
              //保存全部列表
              var user = that.$cookies.get('username');
              if(!user){
                that.$router.push('/login');
                return;
              }

              //保存
              that.$myAxios(that,
                {
                  method: 'POST',
                  url:'/api/Fund/SaveList',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  dataType:'json',
                  data:{
                    username:user,
                    jsonstr:JSON.stringify(newVal)
                  }
                }
                ,res=>{
                  //保存到本地
                  localStorage.setItem('zxFundList',JSON.stringify(newVal))
                  console.log(res.description);
                }
              )
              
              that.calcTotal()
          }
      }
  },
  created()
  {
    var that=this;
    //获取全部列表
    var user = that.$cookies.get('username');
    if(!user){
      that.$router.push('/login');
      return;
    }

    that.$myAxios(that,
    {
      method: 'GET',
      url:'/api/Fund/GetList?username='+user,
    }
    ,res=>{
      //获取自选列表
      that.zxFundList = JSON.parse(res.description)
      that.calcTotal();
      that.refreshTotal();
      console.log(res)
    })

    if(!localStorage.getItem('allFundList')){
        Tools.getFundList().then(list=>{
          that.allFundList = list
        })  
    }
    else
    {
      that.allFundList = JSON.parse(localStorage.getItem('allFundList'))
    } 
  }
}
</script>

<style lang="less" scoped>
.fund{
  max-width:700px;
  margin:15px auto;
  .text-left{
    text-align: left;
  }
  .text-right{
    text-align: right;
  }

  .color-red{
    margin-right: 5px;
    color: red;
  }

  .color-green{
    margin-right: 5px;
    color:green;
  }
}
div.list{
  padding:0px 10px;
  max-height: 200px;
  ul {
    border: #eee 1px solid;
    border-radius: 3px;
    box-shadow: 0 0 2px #eee;
    list-style: none;
    padding: 0px;
    margin:0px;
    height:100%;
    text-align: left;
    overflow-y: auto;
    li{
        padding:3px;
        cursor: pointer;
        :hover{
          color:rgb(1, 110, 253)
        }
    }
}
}
</style>
